export default __webpack_public_path__ + "static/media/EI8.b38887aa.jpg";